












































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';

// import AsociarMensajesForm from '@/pantallas/CopilotoVirtual/Ruta/AsociarMensajesForm.vue';
import AsociarMensajesFormDetalle from '@/pantallas/CopilotoVirtual/Ruta/AsociarMensajesFormDetalle.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import { ServicioProxy } from '@/config/enums';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';
import {
  BaseRuta,
  MensajeSeleccionado,
} from '@/pantallas/CopilotoVirtual/Ruta/rutas';
import { AxiosVue } from '@/AxiosVue';
import { Mensaje } from '@/pantallas/CopilotoVirtual/Mensaje/mensaje';
import AsociarFlotaEtiquetaVehiculoIndividual from '@/reusable/AsociarFlotaEtiquetaVehiculoIndividual/AsociarFlotaEtiquetaVehiculoIndividual.vue';
import moment from 'moment';
import CabeceraTabla from '@/reusable/Grid/CabeceraTabla.vue';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import StepTitle from '@/reusable/Mantenedor/StepTitle.vue';
import {
  codigoAccionesMenuItem,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import { fetchReportesSerie } from './fetchReporteSerie';
import TextField from '@/reusable/Form/TextField.vue';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    CabeceraModalCrear,

    StepTitle,
    CabeceraTabla,
    TextField,
    FormFieldsContainer,

    // AsociarMensajesForm,
    AsociarMensajesFormDetalle,
    NavegacionModalCrud,
    CrudStepperContent,
    CrudStepperItems,
    CrudStepperHeader,
    AsociarFlotaEtiquetaVehiculoIndividual,
  },
})
export default class VerDetalleRutaModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({}) params: any;

  rutasDetalles: BaseRuta[] = [];
  estadoList: any[] = [
    { text: 'Aprobado', value: true },
    { text: 'Rechazado', value: false },
  ];
  mensajes: Mensaje[] = [];

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  vehiculosIdSeleccionar: number[] = [];
  etiquetasIdSeleccionar: number[] = [];
  flotasIdSeleccionar: number[] = [];

  lstEventoMensajes: any[] = [];

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
      title: 'Información de la Autorización',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };
  prueba() {
    var tk = this.params.reporte;
    let _url_base = process.env.VUE_APP_SERVICIO_MS;
    window.open(_url_base + 'descarga_reporte?tk=' + tk, '_blank');
  }
  /* template */

  formFields: FormFieldDefMap = {
    tipooperacion: {
      label: 'Tipo de Operación',
      id: '',
      value: this.params['Tipo de Movimiento'],
    },
    numOperacion: {
      label: 'No. de Operacion',
      id: '',
      value: this.params['Número de Movimiento'],
    },

    fechaSolicitud: {
      label: 'Fecha de Solicitud',
      id: '',
      value: moment(this.params['Fecha de Solicitud']).format(
        'YYYY/MM/DD HH:MM:SS'
      ),
    },
    nombreUsuario: {
      label: 'Solicitante',
      id: '',
      value: this.params['Nombre'] + ' ' + this.params['Apellido Paterno'],
    },
    observacion: {
      label: 'Observacion',
      id: '',
      value: this.params['Observación'],
    },
    fechaRevision: {
      label: 'Fecha de Revisión',
      id: '',
      value: moment().format('YYYY-MM-DD HH:MM:SS'),
    },
    estado_autorizador: {
      label: 'Estado Autorizador',
      id: '',
      value:
        this.params['Estado Autorizador'] != 'Pendiente'
          ? this.params['Estado Autorizador'] == 'Aprobado'
          : '',
    },
    estado: {
      label: 'Estado Solicitud',
      id: '',
      value: this.params['Estado Solicitud'],
    },
    comentario: {
      label: 'Comentario',
      id: '',
      value: this.params['Comentario'],
    },
  };

  async guardar() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      {
        estado: this.formFields.estado_autorizador.value,
        comentario: this.formFields.comentario.value,
        fecha: this.formFields.fechaRevision.value,
        autorizacionNumero: this.params.autonumero,
        usuarioID: JSON.parse(localStorage.getItem('user')).id,
        id_cliente: JSON.parse(localStorage.getItem('user').replace(/'/g, '"'))
          .clienteDefecto,
      },
      'conecta_autorizaciones/autorizar'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrar');
  }
  observar = false;
  mounted() {
    if (this.formFields.estado.value != 'Pendiente') {
      this.observar = true;
    }
  }
}
